export const actionTypes = {
    SELECT_GAME_CHOICE : "SELECT_GAME_CHOICE",
    SELECT_COMPUTER_CHOICE : "SELECT_COMPUTER_CHOICE",
    RESULT_DECICION : "RESULT_DECICION",
    SCORE_COMPUTAION : "SCORE_COMPUTAION",
    FLUSH_STATE : "FLUSH_STATE"
}